var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "list-group",
    class: {
      'list-group-flush': _vm.flush,
      'list-group-horizontal': _vm.direction === 'row',
      'list-group-hide-dividers': !_vm.dividers
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };